import React, { useState, useRef } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Button,
  Grid,
  Switch,
  Typography,
} from '@mui/material';
import useCustomHook from './hooks';
import { useStylesDealerProductsListDialog } from './style';
import { TableComponents, FilterTextField, Icons } from 'components';
import DealerService from '../services';
import { AddAllowedProductDialog } from '.';
import axios from 'axios';
import { useCurrencyUnit } from 'hooks';

const columns = (onChangeStatus = () => {} , currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    cellStyle: {
      width: '1%',
    },
    filtering: false,
    sorting: false,
  },
  {
    title: 'شناسه محصول',
    field: 'productId',
    align: 'center',
    sorting: false,
    filterComponent: (props) => <FilterTextField size="small" isInteger {...props} />,
  },
  {
    title: 'نام محصول',
    field: 'productName',
    align: 'center',
    sorting: false,
    filtering: false,
  },
  {
    title: `قیمت محصول (${currencyText})`,
    field: 'productPrice',
    align: 'center',
    sorting: false,
    filtering: false,
  },
  {
    title: 'وضعیت',
    field: 'enable',
    align: 'center',
    sorting: false,
    filtering: false,
    render: (rd) => <ToggleStatus rd={rd} onChangeStatus={onChangeStatus} />,
  },
];

const DealerProductsListDialog = ({ open, setOpen, dealerBizId }) => {
  const {
    loading,
    setLoading,
    addProductIsOpen,
    setAddProductIsOpen,
    allowedProducts,
    setAllowedProducts,
    size,
    setSize,
    page,
    setPage,
  } = useCustomHook();
  const classes = useStylesDealerProductsListDialog();
  const currencyText = useCurrencyUnit(false);

  const tableRef = useRef();
  const getDealerAllowedProductsList = async (query) => {
    setLoading(true);

    let filterParams = {};
    query?.filters.forEach((f) => {
      filterParams = { ...filterParams, [f.column.field]: f.value };
    });
    try {
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        dealerBizId,
        ...filterParams,
      };

      const res = await DealerService.getDealerAllowedProductsList(params);
      const { result } = res;

      setAllowedProducts(result.map((r) => ({ id: r.product.entityId })));
      const data = result.map((r, key) => ({
        num: query ? query?.page * query?.pageSize : page * size + key + 1,
        productId: r.product?.entityId,
        productName: r.product?.name,
        productPrice: r.product?.price,
        enable: r.enable,
        dealerBizId,
      }));
      setLoading(false);

      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };
  const addAllowedProduct = () => {
    setAddProductIsOpen(true);
  };

  const onChangeStatus = async (dealerBizId, productId, newStatus) => {
    try {
      await DealerService.toggleDealerProductPermission({
        dealerBizId,
        productId,
        enable: newStatus,
      });
      setTimeout(() => {
        tableRef?.current?.onChangeTable(true);
      }, 100);
    } catch (error) {}
  };
  return (
    <>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          لیست محصولات مجوز داده شده
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            size="large"
          >
            <Icons icon="Close" color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <div className={classes.addProductButtonWrapper}>
            <Button
              color="primary"
              variant="contained"
              startIcon={<Icons icon="plusCircle" color="#fff" size="18" />}
              onClick={addAllowedProduct}
            >
              افزودن محصول
            </Button>
          </div>
          {currencyText && (
            <TableComponents
              data={getDealerAllowedProductsList}
              columns={columns(onChangeStatus, currencyText)}
              ref={tableRef}
              isLoading={loading}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getDealerAllowedProductsList(ps);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
      <AddAllowedProductDialog
        open={addProductIsOpen}
        setOpen={setAddProductIsOpen}
        tableRef={tableRef}
        dealerBizId={dealerBizId}
        allowedProducts={allowedProducts}
      />
    </>
  );
};

const ToggleStatus = ({ rd, onChangeStatus }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Grid container alignItems="center" justifyContent="start" style={{ opacity: loading ? 0.4 : 1 }}>
      <Switch
        disabled={loading}
        color="primary"
        onChange={async () => {
          setLoading(true);
          await onChangeStatus(rd?.dealerBizId, rd?.productId, !rd?.enable);
          setLoading(false);
        }}
        checked={rd?.enable}
        className="iosSwitch"
      />
      <Typography>{rd?.enable ? 'فعال' : 'غیرفعال'}</Typography>
    </Grid>
  );
};

export default DealerProductsListDialog;
